module.exports = __webpack_public_path__ + "static/media/iphone-mockup.454c7cd2.png";